export const PROMOTION_STRATE_TYPES = {
  banner: 'promotionBanner',
  cover: 'promotionCover',
} as const;

export const INFO_DISPLAY_MODE = {
  persistent: 'persistent',
  outroOnly: 'outroOnly',
} as const;
